<script>
    import FanfictionSection from './fanfictionSection.svelte';
    import FictionSection from './fictionSection.svelte';
    import HeaderSection from './headerSection.svelte';
    import ProducerPage from './producerPage.svelte';
    import Scriptsection from './scriptsection.svelte';
    import VedioSection from './vedioSection.svelte';
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
</script>

<main>
    <div class="navbar">
        <MobileNavbar />
    </div>
    <div>
        <VedioSection />
    </div>
    <div style="z-index: 3;position:relative;">
        <HeaderSection />
    </div>
    <div>
        <ProducerPage />
    </div>
    <div>
        <Scriptsection />
    </div>
    <div>
        <FictionSection />
    </div>
    <div>
        <FanfictionSection />
    </div>
</main>

<style>
    .navbar {
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 10;
    }
    main {
        background-color: white;
    }
</style>
